/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TaggableFriendsResult } from '../models/TaggableFriendsResult';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ChatTaggingRestControllerService {
    /**
     * Search for taggable users
     * Query in the taggable users to use for the release forms
     * @returns TaggableFriendsResult OK
     * @throws ApiError
     */
    public static getTaggableFriends({
        creatorId,
        offset,
        filter,
        sort,
        order,
        query,
    }: {
        /**
         * The ID of the creator
         */
        creatorId: number,
        /**
         * The offset while using pagination
         */
        offset: number,
        /**
         * The filter to be used (all or pending)
         */
        filter: string,
        /**
         * The sort to be used (name or date)
         */
        sort: string,
        /**
         * The order to be used (desc or asc)
         */
        order: string,
        query: string,
    }): CancelablePromise<TaggableFriendsResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/{creatorId}/taggable-friends',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'offset': offset,
                'filter': filter,
                'sort': sort,
                'order': order,
                'query': query,
            },
        });
    }
}
